// Single source for the product name shown in UI copy.
export const APP_NAME = 'Якобы Работа';
